<template>
    <div>
        <div class="b-banner-box">
            <div class="b-banner-titlebg">
                <div class="b-banner-title">智能巡店访销解决方案</div>
            </div>
        </div>
        <div class="rs-info">
            <div class="rs-info-title">移动巡店访销系统</div>
            <div class="rs-info-title2">采用全新的销售思维 对拜访流程标准化，通过拜访订单获取，提升销售业绩，执行效率和销售预测</div>
            <div class="rs-info-cont">
                <div class="rs-info-cont-l">
                    <img class="rs-t" style="margin-right: 118px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rs-t1.png" alt="">
                </div>
                <div class="rs-info-cont-r">
                    <div class="rs-info-cont-title">拜访计划</div>
                    <div class="rs-info-cont-box">
                        <div class="rs-info-cont-boxC">
                            <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/visit-t1.png" alt="">
                            <div>创建计划</div>
                        </div>
                        <div class="rs-info-cont-boxC">
                            <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/visit-t2.png" alt="">
                            <div>路线规划</div>
                        </div>
                        <div class="rs-info-cont-boxC">
                            <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/visit-t3.png" alt="">
                            <div>计划审批</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rs-info-cont" style="position:relative;bottom: 40px;">
                <div class="rs-info-cont-l" style="display:flex;align-items: flex-end;flex-direction: column;justify-content: flex-end">
                    <div class="rs-info-cont-title">门店拜访</div>
                    <div class="rs-info-cont-box">
                        <div class="rs-info-cont-boxC rs-l">
                            <div class="rs-tcbg">
                                <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/store-t1.png" alt="">
                            </div>
                            <div>拜访.协访</div>
                        </div>
                        <div class="rs-info-cont-boxC rs-l">
                            <div class="rs-tcbg">
                                <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/store-t2.png" alt="">
                            </div>
                            <div>执行</div>
                        </div>
                        <div class="rs-info-cont-boxC rs-l">
                            <div class="rs-tcbg">
                                <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/store-t3.png" alt="">
                            </div>
                            <div>门店数据采集</div>
                        </div>
                        <div class="rs-info-cont-boxC rs-l">
                            <div class="rs-tcbg">
                                <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/store-t4.png" alt="">
                            </div>
                            <div>智能货架盘点</div>
                        </div>
                    </div>
                </div>
                <div class="rs-info-cont-r">
                    <img class="rs-t" style="margin-left: 160px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rs-t2.png" alt="">
                </div>
            </div>
            <div class="rs-info-cont" style="position:relative;bottom: 90px;">
                <div class="rs-info-cont-l">
                    <img class="rs-t" style="margin-right: 40px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rs-t3.png" alt="">
                </div>
                <div class="rs-info-cont-r">
                    <div class="rs-info-cont-title">统计分析</div>
                    <div class="rs-info-cont-box">
                        <div class="rs-info-cont-boxC">
                            <div class="rs-tcbg">
                                <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/statistics-t1.png" alt="">
                            </div>
                            <div>签到</div>
                        </div>
                        <div class="rs-info-cont-boxC">
                            <div class="rs-tcbg">
                                <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/statistics-t2.png" alt="">
                            </div>
                            <div>效能统计</div>
                        </div>
                        <div class="rs-info-cont-boxC">
                            <div class="rs-tcbg">
                                <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/statistics-t3.png" alt="">
                            </div>
                            <div>拜访统计</div>
                        </div>
                        <div class="rs-info-cont-boxC">
                            <div class="rs-tcbg">
                                <img class="rs-tc" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/statistics-t4.png" alt="">
                            </div>
                            <div>销量分析</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "retail-marketing"
    }
</script>

<style lang="less" scoped>
    .b-banner-box{
        margin-top: 7px;
        width: 100%;
        height: 322px;
        background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rs-banner.png") center center no-repeat;
        -webkit-background-size: auto 100%;
        background-size: auto 100%;
        display: flex;
        align-items: flex-end;
        margin-bottom: 50px;
        .b-banner-titlebg{
            width: 100%;
            height: 80px;
            background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/baner-tbg.png") center center no-repeat;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            .b-banner-title{
                width: 1200px;
                height: 80px;
                font-size: 40px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
            }
        }
    }
    .rs-info{
        width: 1200px;
        margin: 50px auto;
        .rs-info-title{
            font-size: 40px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 30px;
        }
        .rs-info-title2{
            font-size: 20px;
            font-weight: 300;
            text-align: center;
            margin-bottom: 130px;
        }
        .rs-info-cont{
            position: relative;
            display: flex;
            align-items: center;

            .rs-info-cont-title{
                font-size: 30px;
                font-weight: bold;
                color: #394354;
                margin-bottom: 38px;
            }
            .rs-info-cont-box{
                display: flex;
                align-items: center;
                .rs-info-cont-boxC{
                    width: 113px;
                    height: 126px;
                    background: #FFFFFF;
                    border: 1px solid #DCDCDC;
                    border-radius: 5px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    font-weight: 500;
                    color: #394354;
                    margin-right: 26px;
                    .rs-tcbg{
                        width: 43px;
                        height: 43px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .rs-tc{
                        margin-bottom: 13px;
                    }
                }
                .rs-l{
                    margin-right: 0;
                    margin-left: 26px;
                }
            }
        }
    }
</style>